<template lang="pug">
  .error-container.flex.content-center.justify-center.flex-wrap
    section.text-center
      h1.title(v-if="code") Error {{ code }}
      h3.subtitle(v-if="message" v-html="message")
</template>

<script>
export default {
    name: 'Error',
    props: {
        code: {
            type: Number,
            required: false
        },
        message: {
            type: String,
            required: false
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"
.error-container
  min-height: 100%
  flex-grow: 1
  color: #aaacb5

  .title
    line-height: 1
    font-size: 2.6em
    font-weight: 200
    margin-bottom: 10px

  .subtitle
    // font-family: $font-alternative
    @apply text-black
    font-size: 1.2em
    font-weight: 300
    margin-top: 10px
    // margin-bottom: 80px
    // text-transform: uppercase
</style>
